import { render, staticRenderFns } from "./PageFifteenth.vue?vue&type=template&id=5ae00698&scoped=true"
import script from "./PageFifteenth.vue?vue&type=script&lang=js"
export * from "./PageFifteenth.vue?vue&type=script&lang=js"
import style0 from "./PageFifteenth.vue?vue&type=style&index=0&id=5ae00698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae00698",
  null
  
)

export default component.exports